<form [formGroup]="formGroup" class="flex justify-between content-stretch items-stretch flex-col h-full">
    <div class="flex-grow">
        <h1 mat-dialog-title tabindex="0" class="!flex justify-between items-end">
            <span class="flex-grow">Edit Organization</span>
            <mat-icon *ngIf="fieldsLocked" class="lock-icon"
                [matTooltip]="lockTooltip">lock</mat-icon>
        </h1>
        <mat-dialog-content class="edit-organization-container !h-full">
            <mat-form-field floatLabel="never" class="flex-1">
                <label for="OrgName">
                    <app-icon icon="asterisk" aria-hidden="true" size="10"></app-icon>
                    <span>Organization Name</span>
                </label>
                <input matInput id="OrgName" formControlName="name">
            </mat-form-field>

            <app-incada-tenant-select 
                *ngIf="showIncadaOption && enableIncada"
                [form]="formGroup"
                [controlName]="'incadaTenant'"
                [disabled]="fieldsLocked && incadaEnabled"
                (tenantSelected)="onTenantSelected($event)">
            </app-incada-tenant-select>

            <mat-checkbox *ngIf="showIncadaOption" 
                [(ngModel)]="enableIncada" 
                [ngModelOptions]="{standalone: true}"
                (change)="onToggleIncada()" 
                [disabled]="fieldsLocked && incadaEnabled" class="mt-2">
                Enable Incada
            </mat-checkbox>
        </mat-dialog-content>
    </div>
    <mat-dialog-actions class="!py-4 flex flex-row justify-end content-end items-end w-full">
        <button mat-button class="btn-default btn-md" (click)="closePopup()" id="cancel_edit_org">Cancel</button>
        <button mat-button class="btn-primary btn-md" [disabled]="!deviceCheckComplete" (click)="save()" id="save_edit_org">Save</button>
    </mat-dialog-actions>
</form>
